export default __webpack_public_path__ + "static/media/no-icon.3ff2d522.svg";